import Vue from 'vue'
import Loading from 'vue-easy-loading'

Vue.use(Loading)
